import Vue from 'vue';
import moment from 'moment';

export default {
  name: 'Quotation',
  props: ['dataObj'],
  data: function () {
    return {
      appData: {},
    }
  },
  created() {
    this.$root.$on('quotation_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appData = this.dataObj;
      });
    },
  },
}